<!-- 监测点实时情况 -->
<template>
  <div v-loading='loading' class='height-percent-100' style='overflow-y: scroll;'>
    <PointInfo v-for='(carrier, key) in carrierList' :key='key' :carrier='carrier' @delPoint='delPoint'
               @updateCarrier='updateCarrierById'></PointInfo>
    <el-empty v-if='!Object.keys(carrierList).length' :description="$t('integration.no_data_temporarily')"></el-empty>
    <AlarmSwitchDialog></AlarmSwitchDialog>
  </div>
</template>

<script>
import bus from '@/utils/bus'
// 监测点的详细数据信息
import PointInfo from './component/PointInfo.vue'
import { getBatchCarrierInfo, getCarrierDetailList, panelSave } from '@/api/modules/monitorPoint'
import AlarmSwitchDialog from '@/components/AlarmSwitch/AlarmSwitchDialog.vue'
import { getIsGuide } from '@/utils/guide'
import { mockMonitorRealTimeList } from '@/common/driver/modules/dataBoard/mock'

export default {
  components: {
    PointInfo,
    AlarmSwitchDialog
  },
  data () {
    return {
      // 展示在展示区的所有数据 由bus从table传入
      carrierList: [],
      // hash版本的carrierList方便检索
      carrierListHash: {},
      loading: true
    }
  },
  mounted () {
    let flag = true
    bus.$on('selectRows', (rows, checked) => {
      if (flag) {
        flag = false
        return
      }
      const newId = this.diffCarrierList(rows)

      if (newId.length) {
        getBatchCarrierInfo({ carrierIds: newId.join(',') }).then(res => {
          res.result.forEach(item => {
            this.carrierList.push(item)
          })
          // this.carrierList = this.carrierList.concat(res.result);
          res.result.forEach(item => this.$set(this.carrierListHash, item.carrier.id, item))
        })
      }

      // this.carrierList=rows;
    })
    this.getPointsDetail()
  },
  beforeDestroy () {
    bus.$off('selectRows')
  },
  methods: {
    // 获取点父级需要调用
    async getPointsDetail () {
      let res = null

      if (getIsGuide()) {
        res = {
          result: mockMonitorRealTimeList()
        }
      } else {
        // 如果拥有Ids则通过ids来批量获取
        if (this.$route.query.ids) {
          res = await getBatchCarrierInfo({ carrierIds: this.$route.query.ids })
        } else {
          res = await getCarrierDetailList()
        }
      }

      res.result.forEach((item, index) => {
        if (item.carrier) {
          this.$set(this.carrierListHash, item.carrier.id, item)
        } else {
          res.result.splice(index, 1)
        }
      })
      this.carrierList = res.result
      this.loading = false
    },
    // 刷新监测点 按照需求 点击刷新，在没有保存监测点设置的时候，应该刷新所有监测区域内的信息
    async refreshPoint () {
      const res = await getBatchCarrierInfo({ carrierIds: this.carrierList.map(item => item.carrier.id).join(',') })
      this.carrierList = res.result
    },
    // 删除单个点
    delPoint (pointId) {
      bus.$emit('cancelSelect', pointId)
      delete this.carrierListHash[pointId]
      const index = this.carrierList.findIndex(item => item.carrier.id === pointId)
      // console.log(index);
      this.carrierList.splice(index, 1)
      // this.carrierList = this.carrierList.filter(item => item.carrier.id !== pointId);
    },

    // 保存 当前监测点  给父级调用
    savePoint () {
      const points = []
      Object.keys(this.carrierListHash).forEach(item => {
        const curItem = this.carrierListHash[item]
        points.push({
          tab: curItem.tab ? 1 : 0,
          carrierId: curItem.carrier.id
        })
      })
      panelSave(points).then(async res => {
        if (res.result) {
          await this.$resultHandle(res.state)
        }
      })
    },
    // 对比新旧监测点列表 找出新增项
    diffCarrierList (rows) {
      rows = rows.map(row => {
        return row.carrierId || row.id
      })
      // 新增的id
      const newIds = []
      rows.forEach(id => {
        // 两种情况 1.新集合中存在 而旧集合中不存在 则是新增  2.新集合中不存在而旧集合中存在则是减少
        if (!this.carrierListHash[id]) {
          newIds.push(id)
        }
      })

      // 需要减少的id
      Object.keys(this.carrierListHash).forEach(key => {
        if (rows.indexOf(parseInt(key)) === -1) {
          this.$delete(this.carrierListHash, key)
          const index = this.carrierList.findIndex(item => item.carrier.id == key)
          this.carrierList.splice(index, 1)
          // this.carrierList = this.carrierList.filter(item => item.carrier.id != key);
        }
      })

      return newIds
    },
    // 更新单个监测点的信息
    updateCarrierById (id) {
      getBatchCarrierInfo({ carrierIds: id }).then(res => {
        const index = this.carrierList.findIndex(item => item.carrier.id === id)
        if (index !== -1 && res.result.length) {
          this.carrierList.splice(index, 1, res.result[0])
          this.$set(this.carrierListHash, id, res.result[0])
        }
      })
    }
  }
}
</script>

<style></style>
